import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteProductsMutation } from "../graphql/mutations";
import type {
  DeleteProductsMutationType,
  DeleteProductsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteProductsMutation = (
  options?: MutationHookOptions<
    DeleteProductsMutationType,
    DeleteProductsMutationVariablesType
  >
) => {
  return useMutation<
    DeleteProductsMutationType,
    DeleteProductsMutationVariablesType
  >(DeleteProductsMutation, options);
};
